import { initializeApp } from "firebase/app";
import * as Auth from "firebase/auth";
import * as Firestore from "firebase/firestore";

export let env: "PROD" | "DEV" = "DEV";
let host = window.location.hostname;
let firebaseConfig = {
    apiKey: "AIzaSyAo3HkaSmxlMO9YlMg7qIBOOLU70ENJWcQ",
    authDomain: "lili-dev-608f0.firebaseapp.com",
    databaseURL: "https://lili-dev-608f0.firebaseio.com",
    projectId: "lili-dev-608f0",
    storageBucket: "lili-dev-608f0.appspot.com",
    messagingSenderId: "766371018901",
    appId: "1:766371018901:web:dcdff94cdbace262f3039c"
};

if ((host !== "app-tne.lili.cool") && (host !== "app-tne-demo.lili.cool")) {
    if ((host === "app.lili.cool") || (host === "lili-dev-608f0.web.app") || (host === "centralperk.web.app") || (host === "localhost")) {
        env = "PROD";
        firebaseConfig = {
            apiKey: "AIzaSyD5fQrShi1qQCgbvQubqA4r6yQzcmd_qlI",
            authDomain: "lili-c7853.firebaseapp.com",
            databaseURL: "https://lili-c7853.firebaseio.com",
            projectId: "lili-c7853",
            storageBucket: "lili-c7853.appspot.com",
            messagingSenderId: "908054617461",
            appId: "1:908054617461:web:473c3eaf0a96c3af85073c",
            measurementId: "G-P17JN801Y5"
        };
    }
} else {
    env = "PROD";
}
console.log({env})

// APP
export const app = initializeApp(firebaseConfig);

// AUTH
export const auth = Auth.getAuth(app);
export const onAuthStateChanged = Auth.onAuthStateChanged;
export const signInWithEmailAndPassword = Auth.signInWithEmailAndPassword;

let authPersistencePromise: Promise<boolean> | undefined;

/**
 * Store the Firebase session for the whole browser origin so a link opened in
 * another tab can restore it. If persistent storage is unavailable, Firebase
 * keeps its current fallback and authentication remains usable in this tab.
 */
export const ensureAuthPersistence = () => {
    if (authPersistencePromise === undefined) {
        authPersistencePromise = Auth.setPersistence(auth, Auth.browserLocalPersistence)
            .then(() => true)
            .catch(() => {
                console.warn("La session ne peut pas être partagée entre les onglets de ce navigateur.");
                return false;
            });
    }
    return authPersistencePromise;
};

// FIRESTORE
export const db = Firestore.getFirestore(app);

export const addDoc = Firestore.addDoc;
export const collection = Firestore.collection;
export const deleteDoc = Firestore.deleteDoc;
export const doc = Firestore.doc;
export const getDoc = Firestore.getDoc;
export const getDocs = Firestore.getDocs;
export const onSnapshot = Firestore.onSnapshot;
export const query = Firestore.query;
export const runTransaction = Firestore.runTransaction;
export const setDoc = Firestore.setDoc;
export const updateDoc = Firestore.updateDoc;
export const where = Firestore.where;
